import { identity } from 'lodash-es';
import { useLocation } from 'react-router-dom';

export const useSearchParam = (searchParam, convert = identity) => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const param = params.get(searchParam);
  return param && convert(param);
};
